import { api } from 'lib/httpClient';
import {
  createFileUploader,
  UploadFileResult as UploadFileResultType,
} from 'further-ui/hooks';

const useFileUpload = createFileUploader(
  api.get,
  `${process.env.REACT_APP_API_URL}/v1/aws/get-signed-post-url`,
);

export default useFileUpload;

export type UploadFileResult = UploadFileResultType;
